// O cliente HTTP da web (TUT-448 e TUT-450).
//
// Cada domínio mora em `lib/api/<domínio>.ts` e exporta um pedaço do objeto;
// a sessão, o CSRF e o `request` moram em `lib/api/infra.ts`. Este arquivo só
// monta o `api` e reexporta o que era público: quem importa de `lib/api` não
// muda.
//
// Duas regras dos módulos:
// - cada um lê o modo (`useDemoApi`) no próprio arquivo, e não por import: o
//   empacotador só dobra `import.meta.env.VITE_API_MODE === "demo"` no módulo
//   que a escreve, e é essa dobra que tira o demo do build de produção (a
//   trava da TUT-433 reprova se ele voltar);
// - método novo nasce no módulo do seu domínio, nunca aqui.
import { apiDaSessao } from "./api/sessao-e-perfil";
import { apiDoPortal } from "./api/portal";
import { apiDosAvisosDoPortal } from "./api/avisos-do-portal";
import { apiDosDocumentosNoPortal } from "./api/documentos-no-portal";
import { apiDoPainel } from "./api/painel";
import { apiDosProcessos } from "./api/processos";
import { apiDosPrazos } from "./api/prazos";
import { apiDosDocumentos } from "./api/documentos";
import { apiDasPericias } from "./api/pericias";
import { apiDasSolicitacoes } from "./api/solicitacoes";
import { apiDosLaudos } from "./api/laudos";
import { apiDasPecas } from "./api/pecas";
import { apiDasConfiguracoes } from "./api/configuracoes";
import { apiDosCadastros } from "./api/cadastros";
import { apiDasOrganizacoesEPessoas } from "./api/organizacoes-e-pessoas";
import { apiDoFinanceiro } from "./api/financeiro";
import { apiDasNotificacoes } from "./api/notificacoes";
import { apiDoOmnichannel } from "./api/omnichannel";
import { apiDasConversas } from "./api/conversas";
import { apiDosFeedbacks } from "./api/feedbacks";
import { apiDosGrupos } from "./api/grupos";
import { apiDosMembros } from "./api/membros";
import { apiDaImportacao } from "./api/importacao";
import { apiDoComercial } from "./api/comercial";
import { apiDosPedidosDeProposta } from "./api/pedidos-de-proposta";
import { apiDosRelatorios } from "./api/relatorios";
import { apiDaFrota } from "./api/frota";
import { apiDosFornecedores } from "./api/fornecedores";
import { apiDasVisoesDeLista } from "./api/visoes-de-lista";
import { apiDosLotes } from "./api/lotes";
import { apiDoPerfilDoEscritorio } from "./api/perfil-do-escritorio";
import { apiDaFichaDaEquipe } from "./api/ficha-da-equipe";
import { apiDasNormas } from "./api/normas";
import { apiDoKpiTecnico } from "./api/kpi-tecnico";
import { apiDasFinalizacoes } from "./api/finalizacoes";
import { apiDosEnvios } from "./api/envios";
import { apiDasDefesas } from "./api/defesas";
import { apiDosProcessosDoPortal } from "./api/portal-processos";

export {
  definirAoPerderSessao,
  recarregar,
  type DeadlineListQuery,
  type DemoDataState,
  type ExpertiseListQuery,
  type FatiaPedida,
  type ProposalListQuery,
} from "./api/infra";

// O erro da API mora em `api-error.ts` para o modo demonstração (`demo-data.ts`)
// poder lançá-lo sem importar de volta deste arquivo.
export { ApiError, ehSessaoAusente } from "./api-error";

export const api = {
  ...apiDaSessao,
  ...apiDoPortal,
  ...apiDosAvisosDoPortal,
  ...apiDosDocumentosNoPortal,
  ...apiDoPainel,
  ...apiDosProcessos,
  ...apiDosPrazos,
  ...apiDosDocumentos,
  ...apiDasPericias,
  ...apiDasSolicitacoes,
  ...apiDosLaudos,
  ...apiDasPecas,
  ...apiDasConfiguracoes,
  ...apiDosCadastros,
  ...apiDasOrganizacoesEPessoas,
  ...apiDoFinanceiro,
  ...apiDasNotificacoes,
  ...apiDoOmnichannel,
  ...apiDasConversas,
  ...apiDosFeedbacks,
  ...apiDosMembros,
  ...apiDosGrupos,
  ...apiDaImportacao,
  ...apiDoComercial,
  ...apiDosPedidosDeProposta,
  ...apiDosRelatorios,
  ...apiDaFrota,
  ...apiDosFornecedores,
  ...apiDasVisoesDeLista,
  ...apiDosLotes,
  ...apiDoPerfilDoEscritorio,
  ...apiDaFichaDaEquipe,
  ...apiDasNormas,
  ...apiDoKpiTecnico,
  ...apiDasFinalizacoes,
  ...apiDosEnvios,
  ...apiDasDefesas,
  ...apiDosProcessosDoPortal,
};
